import type { CurrencyLimit } from '../store/types';

// Wallet and config don't always agree on case, and a code can be missing.
const code = (value: string | null | undefined): string =>
  (value ?? '').toUpperCase();

// The config row for a currency. Most callers want useBetLimits.
export function findCurrencyLimit(
  limits: CurrencyLimit[] | undefined,
  currency: string | null | undefined
): CurrencyLimit | undefined {
  const wanted = code(currency);
  return limits?.find((entry) => code(entry.currencyCode) === wanted);
}
